import './ComingSoon.css'

const messages = [
  "We're crafting the perfect shot list tool — because no one should miss the confetti moment.",
  "Good things take a minute. We're tuning the playlist features to make your soundtrack shine.",
  "We're building this. Slowly. Properly. No half-baked tools here — just quality in the making.",
  "Not live yet — but it's on our radar (and our to-do list). We're packing this feature carefully.",
  "Coming soon-ish. We're making it worth the wait — good things come to those who plan."
]

function ComingSoon({ messageIndex = 0 }) {
  const message = messages[messageIndex] || messages[0]
  
  return (
    <div className="coming-soon-container">
      <p className="coming-soon-message">{message}</p>
    </div>
  )
}

export default ComingSoon
